import { render, staticRenderFns } from "./jobBriefing.vue?vue&type=template&id=3b6f9b0c"
import script from "./jobBriefing.vue?vue&type=script&lang=js"
export * from "./jobBriefing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports